module.exports = __webpack_public_path__ + "static/media/top-logo-902-en-2.6f10b107.png";